<template>
  <div id="promo-app" class="promo-app">
    <Price-Boost v-if="feedLoaded" :scContent="scContent"/>
  </div>
</template>
<script>
import PriceBoost from './components/PriceBoost.vue';

export default {
  name: 'app',
  data () {
    return {
      feedLoaded: false,
      scContent: null,
    }
  },
  components: {
    PriceBoost
  },
  methods: {
    loadSitecoreContent() {
      return new Promise((resolve, reject) => {
        this.scContent = window.promoContent.find(obj => {
          return obj.ItemName === 'content';
        });
        if (this.scContent !== null && this.scContent !== []) {
          resolve();
        }
        reject();
      });
    },
  },
  mounted () {
    this.loadSitecoreContent()
      .then(() => {
        this.$store.dispatch('fetchFeed', this.scContent.FieldValues.Parameters['data_feed-url']).then(() => {
          this.feedLoaded = true;
        });
      });
  }
}
</script>
